import React, { useEffect, useState } from 'react';
import Section from '../ui/Section';
import Field from '../ui/Field';
import { alpha, Button, FormControl, FormLabel, useTheme } from '@mui/material';
import Loader from '../ui/Loader';
import env from '../../config/env';
import api from '../../config/axios';
import { toast } from 'react-toastify';

const ZellerPayment = () => {
    const theme = useTheme();

    const [zelleQr, setZelleQr] = useState('');
    const [zelleDes, setZelleDes] = useState('');
    const [qrZ, setqrZ] = useState([]);
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        readZelle();
    }, []);
    const readZelle = async () => {
        await api
            .get('/invoice/read-zelle')
            .then((res) => {
                setZelleDes(res.data.credentials.description);
                setZelleQr(res.data.credentials.qr);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const updateZelle = async (e) => {
        e.preventDefault();
        setLoader(true);
        console.log(zelleDes);
        console.log(qrZ.length);
        const params = new FormData();
        params.append('description', zelleDes);

        // Only append the image if a new file is selected
        if (qrZ.length > 0) {
            params.append('image', qrZ[0]);
        }

        await api
            .put('/admin/update-zelle', params)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                readZelle();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };
    return (
        <Section title="Zelle">
            <form
                onSubmit={updateZelle}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                }}>
                <Field label="Name" placeholder="Enter Name" name="name" value="ZELLE" disabled />
                <Field
                    label="Description"
                    placeholder="Enter Description"
                    name="description"
                    required
                    value={zelleDes}
                    multiline
                    maxRows={5}
                    onChange={(e) => setZelleDes(e.target.value)}
                />
                <FormControl sx={{ height: '100%' }} fullWidth>
                    <FormLabel sx={{ fontWeight: 600, mb: 0.6 }}>Upload QR Code</FormLabel>
                    <Button
                        variant="outlined"
                        component="label"
                        sx={{
                            height: '100%',
                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                            borderStyle: 'dashed',
                        }}>
                        {zelleQr || '+ Upload QR Code'}

                        <input type="file" id="qrZ" hidden name="qrZ" onChange={(e) => setqrZ(e.target.files)} />
                    </Button>
                </FormControl>

                <img
                    src={env.BASE_API_URL + '/' + zelleQr}
                    alt="zelle"
                    style={{
                        width: '100%',
                        borderRadius: '3.4rem',
                    }}
                />

                <Button type="submit" variant="contained">
                    {loader ? <Loader /> : 'Update Zelle Credentials'}
                </Button>
            </form>
        </Section>
    );
};

export default ZellerPayment;
